import { prettifyProductCode } from "utils/pretty.utils";
import { ProductCodeEnum } from "enums";

export const purchaseOrderProducts = [
  { label: prettifyProductCode(ProductCodeEnum.DIESEL), value: ProductCodeEnum.DIESEL },
  { label: prettifyProductCode(ProductCodeEnum.GAS91), value: ProductCodeEnum.GAS91 },
  { label: prettifyProductCode(ProductCodeEnum.GAS95), value: ProductCodeEnum.GAS95 },
  { label: prettifyProductCode(ProductCodeEnum.GAS97), value: ProductCodeEnum.GAS97 },
];
